import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { ChildType } from "@common/types/tree-types";
import { NameWrapperOurNode } from "./name-wrapper-our-node";
import { NameInputOurNode } from "./name-input-our-node";
import { OurNode } from "@src/cloud-connect/poc/our-node";

interface NamePropTypes {
  child: OurNode;
  type: "initial" | "machine";
  list: ChildType[];
  transferred: boolean;
}

export const NameOurNode = ({
  child,
  type,
  list,
  transferred,
}: NamePropTypes) => {
  const nodeSelectionNodeData = useSelector(
    (state: RootState) => state.yourSlice.nodeSelection.nodeData,
  );

  const nodeSelectionNodeState = useSelector(
    (state: RootState) => state.yourSlice.nodeSelection.state,
  );
  const nodeSelectionNodeEditedState = useSelector(
    (state: RootState) => state.yourSlice.nodeSelection.edited,
  );

  return (
    <>
      {child.key === nodeSelectionNodeData.key &&
      nodeSelectionNodeState === "none" &&
      child.name !== "Root" &&
      type === "machine" &&
      nodeSelectionNodeEditedState ? (
        <NameInputOurNode
          child={child}
          nodeSelectionNodeData={nodeSelectionNodeData}
        />
      ) : (
        <NameWrapperOurNode
          list={list}
          type={type}
          child={child}
          transferred={transferred}
        />
      )}
    </>
  );
};
